import React, { useState } from "react";
import "./Add_Payment_Method";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Button, Form } from "react-bootstrap";
import Common_white_header from "../../Common/Common_Component/Common_white_header/Common_white_header";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Add_Payment_Method() {
  const [phone, setPhone] = useState("");
  return (
    <>
      <section className="Add_Payment_Method">
        <Common_white_header headingText={"Payment Method"} />

        <div className="container">
          {/* UPI name */}
          <div className="form-group field_holder">
            <Form.Label>
              <img
                src="/assets/images/icons/phone.png"
                alt="icon"
                className="login_lable_icons"
              />{" "}
              UPI name
            </Form.Label>

            <Form.Control type="text" placeholder="EnterUPI name" />
          </div>

          {/* Phone Number */}
          <div className="form-group field_holder">
            <Form.Label>
              <img
                src="/assets/images/icons/phone.png"
                alt="icon"
                className="login_lable_icons"
              />{" "}
              Phone number
            </Form.Label>

            <PhoneInput
              country={"in"}
              value={phone}
              onChange={(phone) => setPhone(phone)}
              inputClass="custom-phone-input"
              containerClass="custom-phone-container"
              buttonClass="custom-phone-button"
            />

            <p className="red_note_holder">
              <FontAwesomeIcon icon={faCircleInfo} className="me-3" /> For
              security of your account, Please fill in your real mobile phone
              number
            </p>
          </div>

          {/* UPI name */}
          <div className="form-group field_holder">
            <Form.Label>
              <img
                src="/assets/images/icons/phone.png"
                alt="icon"
                className="login_lable_icons"
              />{" "}
              UPI ID
            </Form.Label>

            <Form.Control type="text" placeholder="Please Enter your UPI ID" />
          </div>

          {/* UPI name */}
          <div className="form-group field_holder">
            <Form.Label>
              <img
                src="/assets/images/icons/phone.png"
                alt="icon"
                className="login_lable_icons"
              />{" "}
              Confirm UPI ID
            </Form.Label>

            <Form.Control type="text" placeholder="Please Enter your UPI ID" />
          </div>

          {/* Save Button */}
          <Button className="gray_btn my-4">Save</Button>
        </div>
      </section>
    </>
  );
}

export default Add_Payment_Method;
